import _ from "lodash";
import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import AppFooter from "@components/AppFooter/AppFooter";
import AppNavbar from "@components/AppNavbar/AppNavbar";
import ProjectCard from "@components/ProjectCard/ProjectCard";
import GeneralConst from "@consts/GeneralConst";
import logoBlack from "@images/logos/logoBlack.png";
import GeneralStrings from "@strings/GeneralStrings.json";
import SpotifyService from "@services/SpotifyService";
import "./ProjectsPage.scss";

const title = `Projects | ${GeneralConst.SITE_NAME}`;
const projectStrings = GeneralStrings.projects;

let projectsCache: Promise<Project[]> | null = null;

export const resetProjectsCache = () => {
  projectsCache = null;
};

const fetchProjectsOnce = (): Promise<Project[]> => {
  if (!projectsCache) {
    projectsCache = SpotifyService.getArtistAlbums().then(
      (res: any) => res?.data?.items ?? [],
    );
    projectsCache.catch(() => {
      projectsCache = null;
    });
  }
  return projectsCache;
};

const ProjectPage = () => {
  const [projects, setProjects] = useState<Project[]>([]);
  const byType = _.groupBy(projects, "album_type");

  const renderGroup = (albumType: string, header: React.ReactNode, colClass: string) => {
    const items = byType[albumType];
    if (!items?.length) return null;
    return (
      <>
        <h4 className="project-group-header">{header}</h4>
        <div className="row">
          {items.map((project) => (
            <div className={colClass} key={"project-" + project.name}>
              <ProjectCard project={project} />
            </div>
          ))}
        </div>
      </>
    );
  };

  useEffect(() => {
    fetchProjectsOnce()
      .then(setProjects)
      .catch(() => {});
  }, []);

  return (
    <Fragment>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <AppNavbar transparentNavbar={false} />
      <section className="projects">
        <div className="container">
          <div className="title-area">
            <h2>{projectStrings.projects}</h2>
            <div className="separator">
              <img src={logoBlack} className="seperator-img" alt="logo" />
            </div>
            <h4 className="description">{projectStrings.description}</h4>
          </div>
          <div className="projects-container">
            {renderGroup("album", projectStrings.albums, "col-sm-12 col-md-3")}
            {renderGroup("single", <><span style={{ color: "var(--plate-gold-500)" }}>Singles</span>{" & EPs"}</>, "col-sm-6 col-md-4 col-lg-3")}
            {renderGroup("compilation", projectStrings.appearsOn, "col-sm-12 col-md-3")}
            {renderGroup("appears_on", projectStrings.appearsOn, "col-sm-12 col-md-3")}
          </div>
        </div>
      </section>
      <AppFooter />
    </Fragment>
  );
};

export default ProjectPage;
